import basecolors from './basecolors';
import semanticcolors from './semanticcolors';

export default {
  ...basecolors,
  ...semanticcolors,
};
